import React, { useState } from 'react';
import CategoryArt from '@/components/brand/CategoryArt';

/**
 * A product's picture: its own photo when it has one, otherwise the
 * artwork for its category. A photo that fails to load (deleted, link
 * expired, offline) falls back to the artwork too, instead of the
 * browser's broken-image icon.
 *
 * Works for products and inventory rows (both carry image_url and
 * category). Fills its container: size the parent.
 */
export default function ProductImage({ product, className = '' }) {
  const [failed, setFailed] = useState(false);
  const src = product?.image_url;
  if (src && !failed) {
    return (
      <img
        src={src}
        alt=""
        loading="lazy"
        className={`w-full h-full object-cover ${className}`}
        onError={() => setFailed(true)}
        data-testid="product-photo"
      />
    );
  }
  return (
    <CategoryArt
      category={product?.category || product?.product_category}
      variantKey={product?.id || product?.name || product?.product_name}
      className={className}
    />
  );
}
